module.exports = __webpack_public_path__ + "img/biglogo.0587e8aa.png";